/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { get, getJson } from 'session';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import StudentModal from '../modals/StudentModal';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import ConfirmAlertWithAmount from 'modules/common/components/ConfirmAlertWithAmount';
import StudentContent from './StudentContent';

import * as actions from '../action';
import * as c from '../constant';

const form = {
  keyword: '',
  status: '',
  type: 'STUDENT',
};


function StudentContainer({
  permissions,
  history,
  match,
  isLoading,
  showStudent,
  studentList,
  getStudentList,
  studentListPager,
  approveTransaction,
  rejectTransaction,
}) {
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};
  const setModal = useContext(ModalContext);

  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  const [countChar, setCountChar] = useState(0);

  const UpdateData = () => {

    getStudentList({ type: 'STUDENT' });
  };

  const param = {
    type: 'STUDENT',
    q: formData.keyword,
    sort_by: 'asc',
    status: filter.status,
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);
  };

  useEffect(() => {
    UpdateData();
  }, []);

  const handleOnChangeSelect = (key) => (e) => {
    setFilter({
      ...filter,
      [key]: e.value,
      status: e.value,
    });
    getStudentList({ ...filter, status: e.value });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <StudentModal actionType="ADD" />,
      title: 'Add Citizen',
      modalSize: 'modal-lg',
    });
  };

  const debouncedSearchTerm = useDebounce(formData, 500);
  useEffect(() => {
    if (debouncedSearchTerm && countChar >= 3) {
      getStudentList({ type: 'STUDENT', q: formData.keyword });
    } else {
      getStudentList({ type: 'STUDENT' });
    }
  }, [debouncedSearchTerm]);

  // handle Approve button
  const handleApprove = (data) => (e) => {
    e.preventDefault();

    // const args = {
    //   status: 'APPROVED',
    //   amount: '12000',
    //   remarks: 'random test 3',
    // }
    // approveTransaction(
    //   _.get(data, 'id'),
    //   args,
    //   () => {
    //     showStudentList(_.get(data, 'id'));
    //     console.log('studentInfo', studentInfo)
    //   }
    // );

    ConfirmAlertWithAmount(
      'Are you sure, you want to Approve this application?',
      (remarks, amount) => {

        const args = {
          status: 'APPROVED',
          remarks,
          amount,
          type: 'STUDENT',
        }
        approveTransaction(
          _.get(data, 'id'),
          args,
          () => {
            showStudentList(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  // const aprove = (data) => (e) => {
  //   e.preventDefault();
  //   const args = {
  //     status: 'APPROVED',
  //     amount: '5000.00',
  //     remarks: 'testing'
  //     // type: 'SENIOR',
  //   }

  //   approveTransaction(
  //     _.get(data, 'id'),
  //     args,
  //     () => {
  //       showStudentList(_.get(data, 'id'));
  //       console.log('approveTransaction', approveTransaction(_.get(data, 'id'), args, () => { showStudentList(_.get(data, 'id'))}))
  //     }
  //   );
  // }



  // handle reject button
  const handleReject = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Reject this application',
      (remarks) => {
        rejectTransaction(
          _.get(data, 'id'),
          {
            remarks,
            status: 'REJECTED'
          },
          () => {
            showStudent(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const exportCSV = () => {

    const handleExportCsv = e => {
      e.preventDefault();

      const src = `${process.env.REACT_APP_WS
        }/api/v1/administrators/export/social_amelioration_citizens?bearer_token=${token}&email=${_.get(authProfile, 'email')}&type=${param.type}&q=${param.q}&output=D`;

      setTimeout(() => {
        window.location.href = src;
      }, 500);
    }

    return (
      <div className="d-flex align-items-center px-0 pt-2">
        {Acl(permissions, ['SOCIAL AMELIORATION STUDENT EXPORT CSV']) && (
          <button
            onClick={handleExportCsv}
            className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary w-100"
          >
            Export Student List to CSV
          </button>
        )}
      </div>
    )
  };

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName=""
            getData={getStudentList}
            setParams={param}
            setKeyword={handleOnChange}

            setStatusFilter={handleOnChangeSelect(
              _.get(formData, 'status')
            )}
            status={_.get(filter, 'status') || ''}
            keyword={_.get(formData, 'keyword') || ''}

            keywordPlaceholder="Search Transaction..."
            pathName={`${match.path}/:id?`}
            // listName="Transaction"
            label="Citizen Lists"
            // LEFT SECTION
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="senior-citizen-list">
                  {`${_.get(item, 'attributes.first_name') || ''} ${_.get(item, 'attributes.middle_name') || ''} ${_.get(item, 'attributes.last_name') || ''}`}
                </div>
                <h4 className="mt-1 mb-0 senior-citizen-list-numbers">
                  {' '}{_.get(item, 'attributes.contact_number')}{' '}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            // statusFilter
            selected={params.id}
            data={studentList}
            dataPager={studentListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            // RIGHT SECTION
            renderTopContent={() => (
              <div className="w-100 d-flex px-3 pb-3">
                {Acl(permissions, ['SOCIAL AMELIORATION STUDENT ADD']) && (
                  <button
                    type="button"
                    onClick={handleAddModal}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
                    style={{ height: "32px" }}
                  >
                    <i className="fas fa-plus" /> &nbsp;&nbsp;
                    Add Student
                  </button>
                )}
              </div>
            )}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <StudentContent
                        UpdateData={UpdateData}
                        testingApprove={handleApprove}

                        onApprove={handleApprove}
                        onReject={handleReject}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.studentId && studentList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(studentList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            customButton={exportCSV()}
          />
        )}
      />
    </div>
  );
}

StudentContainer.propTypes = {
  permissions: PropTypes.instanceOf(Array).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  studentList: PropTypes.instanceOf(Object).isRequired,
  getStudentList: PropTypes.instanceOf(Function).isRequired,
  studentListPager: PropTypes.instanceOf(Object).isRequired,
  showStudent: PropTypes.instanceOf(Function).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  rejectTransaction: PropTypes.instanceOf(Function).isRequired,

};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  isLoading: api.loading.indexOf(c.GET_STUDENT) > -1,
  studentList: _.get(api, `${c.GET_STUDENT}.list`) || [],
  studentListPager: _.get(api, `${c.GET_STUDENT}.pager`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(StudentContainer);